import NavHeader from "./src/NavHeader.vue";

export default NavHeader;
